<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Proxy</strong>
      </span>
      
         
        
      <span style="float:right">
        <!-- <a routerLink="/proxy/add"> -->
          <button (click)="add()" class="btn btn-success pull-right" [appHasPermission]="{'Url': '/register/proxy/edit?goveva=true&email=', 'method':'put', 'menu': 'Proxy'}"
          class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
        <span>
          <i class="fa fa-save"></i>&nbsp;Generate Output </span>
      </button>
    </span>
  
   
    </div>
  
    <!-- Data Filter  -->
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span>
      </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3">
                <label>Folio Number</label>
                <input type="text" class="form-control" [(ngModel)]="searchByFolioNumber">
              <br>
              </div>
  
              <div class="col-md-3">
                <!-- <label>Date of receipt of Proxy Form</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From:&nbsp;
                  <input id="dateOfReceiptOfProxy" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfReceiptOfProxy" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfReceiptOfProxy">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>
  
              <div class="col-md-3">
                
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  To:&nbsp;
                  <input id="dateOfReceiptOfProxyTo" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfReceiptOfProxyTo" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfReceiptOfProxyTo">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
              <div class="col-lg-2 col-md-2 col-sm-2">
                <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                <br>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfProxy" [dtTrigger]="dtTriggerProxy"
                class="table table-hover compact cell-border nowrap stripe" id="proxymasterTable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Folio Number</th>
                    <th>Name of the Member appointing <br>the Proxy</th>
                    <th>Name of the Proxy (ies) <br>Appointed</th>
                    <th>Date of receipt of Proxy Form</th>
                    <th style="display: none">Date of receipt of Proxy Form</th>
                    <th class="actionclass">Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let proxies of registerProxyList;">
                    <td>{{proxies.folioNumber}}</td>
                    <td>{{proxies.nameOfTheMentor}}</td>     
                    <td>{{proxies.nameOfProxy}}</td>
                   
                    <td>
                      <span style="display: none">{{proxies.dateOfReceiptOfProxy | date : "yMMdd"}}</span>
                      {{proxies.dateOfReceiptOfProxy | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none">
                      {{proxies.dateOfReceiptOfProxy | date : "dd-MM-y"}}
                    </td>
                    <td>
                      <button type="button" (click)="editproxy(proxies._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/proxy/edit?goveva=true&email=', 'method':'put', 'menu': 'Proxy'}">
                        <span class="fa fa-pencil"></span>
                      </button>
                      <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(proxies._id)" [appHasPermission]="{'Url': '/register/proxy/edit?goveva=true&email=', 'method':'put', 'menu': 'Proxy'}">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <!-- delete Modal -->
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete proxy details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteProxies()" data-dismiss="modal">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-alert></app-alert>